import { selectFormById } from "@overmap-ai/core"
import { createFileRoute, notFound } from "@tanstack/react-router"
import { appStore } from "src/store"
import { formDetailViewStaticData } from "src/views/FormDetailsView/constants"
import { FormDetailView } from "src/views/FormDetailsView/FormDetailView"
import { NotFound } from "src/views/FormDetailsView/NotFound"

export const Route = createFileRoute("/_loggedIn/$organizationId/_map/_layout/forms/$formId/")({
	component: FormDetailView,
	errorComponent: NotFound,
	staticData: formDetailViewStaticData,
	loader: ({ params }) => {
		const form = selectFormById(params.formId)(appStore.getState())
		if (!form) throw notFound()
	},
})
